import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-8 md:py-14 bg-sage text-white relative overflow-hidden" data-id="element-136">
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage-400 rounded-full blur-3xl opacity-20" data-id="element-137"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-sage-700 rounded-full blur-3xl opacity-40" data-id="element-138"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-140">
          <ShieldCheck className="w-14 h-14 md:w-20 md:h-20 text-gold mb-4 md:mb-6" data-id="element-141" />
          <h2 className="text-2xl md:text-5xl font-bold font-playfair mb-5 md:mb-8" data-id="element-142">
            GARANTÍA PILATES 360 — 7 DÍAS
          </h2>

          <div className="space-y-3 text-sm md:text-xl text-sage-50 mb-6 md:mb-8 max-w-2xl" data-id="element-143">
            <p data-id="element-144">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
              querés.
            </p>
            <p className="font-bold text-white text-lg md:text-2xl py-2 md:py-4" data-id="element-145">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-146" />
              Te devolvemos el 100%.
            </p>
            <p data-id="element-147">Sin preguntas. Sin formularios. Sin drama.</p>
          </div>

          <div className="bg-sage-800/50 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-sage-600/50 max-w-xl" data-id="element-148">
            <p className="text-xs md:text-sm text-sage-200" data-id="element-149">
              La confianza que tenemos en PILATES 360 nos permite hacer esa
              promesa sin dudar. Más de 500 instructoras de Pilates de todo el
              país ya lo saben.
            </p>
            <p className="font-bold text-gold mt-2 text-sm md:text-base" data-id="element-150">
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};